module.exports = __webpack_public_path__ + "static/media/[Philm]2011-09-05.59d29317.md";